import { addCommas } from '@persian-tools/persian-tools';

export const numberSeparator = (number: number | string) => addCommas(number);
